module.exports = __webpack_public_path__ + "static/media/20x30no1.00d4060e.jpg";